import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-000cefdd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "terminal-wrap"
}
const _hoisted_2 = { class: "left-wrap" }
const _hoisted_3 = { class: "right-wrap el-card" }
const _hoisted_4 = { class: "filter-row" }
const _hoisted_5 = { class: "cm-align-center" }
const _hoisted_6 = { style: {"display":"flex"} }
const _hoisted_7 = { class: "terminal-table-panel" }
const _hoisted_8 = { class: "drawer-footer" }

import { ref, computed, watch, nextTick, unref, PropType } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { Group } from '@/views/dashboard/_type/group'
import BaseTree from '@/views/dashboard/_components/group-tree/base-tree.vue'
import Axios from 'axios'
import { collapseErrorMessage } from '@/common/error/error-code'
import { SelectTerminalDrawerService } from './select-terminal-drawer.service'
import { ClientItem } from '@/views/dashboard/_type/client-item'
import { calculateSubnetInfo } from '@/utils/index'
import CmTable from '@/components/cmTable/index.vue'
import type { TableOpt } from '@/components/cmTable/types'
import { computerInfoCols } from '../../data-safe/ransomware-protection/types/ransomware-incident'
import { useI18n } from 'vue-i18n'
import type { PolicyType } from '@/views/dashboard/_enum/policy-type'


export default /*#__PURE__*/_defineComponent({
  __name: 'select-terminal-drawer',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  },
  /** 可以传终端列表，也可以传设备id列表（父组件需要回显终端明细的不适用） */
  propSelectedData: {
    type: Array as () => Array<ClientItem | string>,
    default: () => []
  },
  subnet_address: {
    type: String,
    default: ''
  },
  systemTypes: {
    type: Array as () => Array<number>,
    default: () => []
  },
  title: {
    type: String,
    default: ''
  },
  maxCount: {
    type: Number,
    default: undefined
  },
  /** 与 GroupEdit 一致：分组树接口 permission_name */
  permissionKey: {
    type: String,
    default: ''
  },
  /** 与 GroupEdit 一致：分组树接口 strategy_type */
  strategyOver: {
    type: Object as PropType<{ type?: PolicyType; current?: string }>,
    default: () => ({})
  }
},
  emits: ['update:modelValue', 'confirm'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const props = __props

const treeCustomApiParams = computed(() => ({
  strategy_type: props.strategyOver?.type,
  permission_name: props.permissionKey
}))

const emit = __emit

const injector = useReflectiveInjector([SelectTerminalDrawerService])
const service = injector.get(SelectTerminalDrawerService)

/** CmTable 实例（含 getList、tableRef、rowData 等 expose） */
const tableRef = ref<{
  getList: (keepPage?: boolean) => Promise<unknown>
    tableRef?: { clearSelection: () => void; toggleRowSelection: (row: ClientItem, selected?: boolean) => void }
    rowData?: { terminal_list?: ClientItem[] }
  } | null>(null)
  const { refreshList } = useCmTableListRefresh(tableRef)
let getDataCancel: (() => void) | undefined

const searchParams = ref({
  searchKey: ''
})

const groupId = ref(-1)
const selectedData = ref<ClientItem[]>([])

const pageOption = {
  pageNumName: 'page',
  pageSizeName: 'limit'
}

const queryParams = computed(() => ({
  group_id: groupId.value,
  key_word: searchParams.value.searchKey,
  system_types: props.systemTypes,
  subnet_address_start: props.subnet_address ? calculateSubnetInfo(props.subnet_address).fullRangeStart : undefined,
  subnet_address_end: props.subnet_address ? calculateSubnetInfo(props.subnet_address).fullRangeEnd : undefined
}))

const tableOpt: TableOpt = {
  bodyStyle: { padding: 0 },
  showActionBar: false,
  showSearch: false,
  showRightToolbar: false,
  height: '100%',
  path: 'terminal_list',
  totalPath: 'total',
  selection: true,
  hiddenPageTool: true,
  rowKey: 'device_id',
  reserveSelection: true,
  columns: computerInfoCols(false, true, t)
}

const drawerVisible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})

const drawerTitle = computed(() => props.title || t('selectTerminalDrawer.defaultTitle'))

const selectedCount = computed(() => {
  return selectedData.value.length
})

const selectedTagText = computed(() => {
  if (typeof props.maxCount === 'number') {
    return t('selectTerminalDrawer.selectedWithMax', { current: selectedCount.value, max: props.maxCount })
  }
  return t('selectTerminalDrawer.selectedOnly', { count: selectedCount.value })
})

function getListApi (params: Record<string, unknown>) {
  getDataCancel && getDataCancel()
  const info = calculateSubnetInfo(props.subnet_address || '')
  return service.getTerminalList({
    key_word: params.key_word as string,
    page: params.page as number,
    limit: 999999, // params.limit as number,
    group_id: params.group_id as number,
    system_types: props.systemTypes,
    subnet_address_start: props.subnet_address ? info.fullRangeStart : undefined,
    subnet_address_end: props.subnet_address ? info.fullRangeEnd : undefined
  }, {
    cancelToken: new Axios.CancelToken((callback) => {
      getDataCancel = callback
    })
  })
}

async function terminalGroupSelected (row: Group) {
  groupId.value = row.group_id
  // 等父级把新的 queryParams 下发到 CmTable 后再请求，否则 getList 读到的是上一分组的参数（慢一拍）
  await nextTick()
  await refreshList()
  initSelected()
}

function handleSearch () {
  void refreshList()
}

function handleSelectionChange (selection: ClientItem[]) {
  if (props.maxCount && selection.length > props.maxCount) {
    collapseErrorMessage(t('selectTerminalDrawer.maxTerminalsMessage', { max: props.maxCount }))
    const lastSelected = selection[selection.length - 1]
    tableRef.value?.tableRef?.toggleRowSelection(lastSelected, false)
    selectedData.value = selection.slice(0, props.maxCount)
  } else {
    selectedData.value = selection
  }
}

async function initSelected () {
  const elTable = tableRef.value?.tableRef
  if (!elTable?.toggleRowSelection) return
  const res = unref(tableRef.value?.rowData) as { terminal_list?: ClientItem[] } | undefined
  const rows = res?.terminal_list ?? []
  if (!rows.length) return
  const selectedIds = new Set(selectedData.value.map((r) => r.device_id))
  rows.forEach((row) => {
    if (selectedIds.has(row.device_id)) {
      elTable.toggleRowSelection(row, true)
    }
  })
}

function initSelectedData () {
  const list = props.propSelectedData.map(v => {
    if (typeof v === 'string') {
      return { device_id: v } as ClientItem
    }
    return v
  })
  selectedData.value = list.slice(0, props.maxCount)
}

function handleConfirm () {
  emit('confirm', selectedData.value)
  emit('update:modelValue', false)
}

function handleCancel () {
  emit('update:modelValue', false)
}

function resetData () {
  tableRef.value?.tableRef?.clearSelection()
  selectedData.value = []
}

watch(() => drawerVisible.value, async (val) => {
  if (val) {
    searchParams.value.searchKey = ''
    groupId.value = -1
    initSelectedData()
    await nextTick()
    // 列表首载交由 BaseTree 请求分组后 terminalGroupSelected → getList，避免与此处 getList 重复请求
  } else {
    resetData()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: drawerVisible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((drawerVisible).value = $event)),
    title: drawerTitle.value,
    size: "80%",
    "append-to-body": "",
    "destroy-on-close": "",
    "custom-class": "terminal-select-wrap terminal-select-dialog"
  }, {
    default: _withCtx(() => [
      (drawerVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(BaseTree, {
                dataApi: "/terminal-group/team-list",
                subnet_address: __props.subnet_address,
                terminalType: __props.systemTypes,
                "custom-api-params": treeCustomApiParams.value,
                onTerminalGroupSelected: terminalGroupSelected
              }, null, 8, ["subnet_address", "terminalType", "custom-api-params"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_tag, {
                    size: "small",
                    type: "primary",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(selectedTagText.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_input, {
                    style: {"min-width":"300px"},
                    size: "small",
                    modelValue: searchParams.value.searchKey,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.searchKey) = $event)),
                    placeholder: _unref(t)('common.phMacFull'),
                    onChange: handleSearch,
                    "suffix-icon": "el-icon-search"
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(CmTable, {
                  ref_key: "tableRef",
                  ref: tableRef,
                  "table-opt": tableOpt,
                  api: getListApi,
                  modelValue: queryParams.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams).value = $event)),
                  "page-option": pageOption,
                  "first-loading": false,
                  onChangeSelected: handleSelectionChange
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          size: "small",
          onClick: handleCancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('common.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: handleConfirm,
          disabled: selectedCount.value === 0
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('common.confirm')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})